import React, { useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import { FormikSelectTwoSmall } from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../../Components/Utils/Download";
import useFetchMDIndex from "../../../../../../Components/Hooks/useFetchMDIndex";

function ContractReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Contracts"
  );

  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Client",
      width: "15%",
      field: "Client",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Description",
      width: "15%",
      field: "Description",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Start Date",
      width: "15%",
      field: "StartDate",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "End Date",
      width: "15%",
      field: "EndDate",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Amount",
      width: "15%",
      field: "Amount",
      textAlign: "left",
      rowAlign: "left",
      type: "amount",
    },
    {
      title: "Status",
      width: "15%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    status: "",
    startDateFrom: "",
    startDateTo: "",
    endDateFrom: "",
    endDateTo: "",
  });

  const [params, setParams] = useState({
    status: "",
    startDateFrom: "",
    startDateTo: "",
    endDateFrom: "",
    endDateTo: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
        status: value.status,
        startDateFrom: value.startDateFrom,
        startDateTo: value.startDateTo,
        endDateFrom: value.endDateFrom,
        endDateTo: value.endDateTo,
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-contracts",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
    });
  }

  return (
    <>
      <div className="w-full h-full overflow-auto">
        <div className="w-full   items-center gap-x-3">
          <div className="flex gap-x-2 justify-between  w-full  py-2">
            <div className=" max-w-[250px] pr-7 ">
              <p className=" font-semibold text-xs 2xl:text-sm  ">
                Contracts : {data?.length}
              </p>
            </div>
            <div className=" flex-1 ">
              <form onSubmit={formik.handleSubmit}>
                <div className=" w-full grid grid-cols-4  2xl:grid-cols-5 gap-3">
                  <NuDateSmall
                    label="Start Date From "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="startDateFrom"
                    width="w-full"
                  />
                  <NuDateSmall
                    label="Start Date To "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="startDateTo"
                    width="w-full"
                  />
                  <NuDateSmall
                    label="End Date From "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="endDateFrom"
                    width="w-full"
                  />
                  <NuDateSmall
                    label="End Date To "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="endDateTo"
                    width="w-full"
                  />
                  <FormikSelectTwoSmall
                    label="Status"
                    Options={status}
                    formik={formik}
                    placeholder="Choose"
                    name="status"
                    width="w-full "
                  />
                  <div className=" w-full flex justify-end ">
                    <div className=" w-full flex items-end gap-2">
                      <SubmitButton name="Apply" />
                      <CancelButton
                        label="Clear"
                        handleClick={closeFilterDialog}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className=" w-[80px] flex justify-end items-end gap-4 ">
              <DownloadPDF
                url={`/xlsx-report/export-clients-pdf`}
                fileName="Contracts Report"
                params={params}
              />
              <DownloadXLXS
                url={`/xlsx-report/export-contracts-xlsx`}
                fileName="Contracts Report"
                params={params}
              />
            </div>
          </div>
        </div>
        <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default ContractReport;
